import { Row, Col, Container, Spinner, Button, Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import TpIcapCardHeader from '../../features/tpIcapCardHeader/TpIcapCardHeader';
import details_thumbnail from '../../images/trader_details_thumbnail.png';
import summary_thumbnail from '../../images/summary_thumbnail.png';
import pm_overview from '../../images/pm_overview.png';
import trader_thumbnail from '../../images/trader_overview.png';
import outliers_thumbnail from '../../images/outliers_thumbnail.png';
import config from '../../config';
import AssetClass from '../../common/domain/AssetClass';

const TpIcapCardBody = styled(CardBody)`
  padding: 5px 20px 20px 20px !important ;
  height: 28em;
`;

export interface FixedDashboardProps {
    assetClass?: AssetClass;
}

const renderFixedDashboards = (assetClass?:AssetClass) => {
    if(assetClass == null) {
        return (
        <Row>
            <Col md="4">
                <Spinner /> Loading
            </Col>            
        </Row>
        )
    }    
    const fixedDashboards = config.dashboards[assetClass.id]
    return (
        <Row>
            { fixedDashboards.ids['summary'] != 'na' && 
            <Col md="4">
            <Link to={`/dashboard/${fixedDashboards.ids['summary']}`}>
                <Card>
                <TpIcapCardHeader>
                    <h3 className="mt-0">Summary</h3>
                </TpIcapCardHeader>
                <TpIcapCardBody>
                    <div className="text-center mb-4">
                    <img src={summary_thumbnail} alt="" />
                    </div>
                    <p>
                    High level overview of your data enriched with market and
                    reference data to deliver performance measurements,
                    statistics and other analytics in both chart and table
                    formats. Data in this dashboard are sliced and grouped by
                    generic security attributes.
                    </p>
                </TpIcapCardBody>
                </Card>
            </Link>
            </Col>
            }
            { fixedDashboards.ids['pmoverview'] != 'na' && 
            <Col md="4">
            <Link to={`/dashboard/${fixedDashboards.ids['pmoverview']}`}>
                <Card>
                <TpIcapCardHeader>
                    <h3 className="mt-0">PM Overview</h3>
                </TpIcapCardHeader>
                <TpIcapCardBody>
                    <div className="text-center mb-4">
                    <img src={pm_overview} alt="" />
                    </div>
                    <p>
                    High level overview of your data enriched with market and
                    reference data to deliver performance measurements,
                    statistics and other analytics in both chart and table
                    formats. Data in this dashboard are sliced and grouped by
                    generic security attributes as well as any information in
                    your files on the Portfolio Manager, Order Size, Account
                    and/or Fund.
                    </p>
                </TpIcapCardBody>
                </Card>
            </Link>
            </Col>
            }
            { fixedDashboards.ids['traderoverview'] != 'na' && 
            <Col md="4">
            <Link
                to={`/dashboard/${fixedDashboards.ids['traderoverview']}`}
            >
                <Card>
                <TpIcapCardHeader>
                    <h3 className="mt-0">Trader Overview</h3>
                </TpIcapCardHeader>
                <TpIcapCardBody>
                    <div className="text-center mb-4">
                    <img src={trader_thumbnail} alt="" />
                    </div>
                    <p>
                    High level overview of the client’s data enriched with
                    market and reference data to deliver performance
                    measurements, statistics and other analytics in both chart
                    and table formats. Data in this dashboard are sliced and
                    grouped by generic security attributes as well as any
                    information in your files on the Trader, Trade Desk, Trade
                    Size, Dealer and/or Venue.
                    </p>
                </TpIcapCardBody>
                </Card>
            </Link>
            </Col>
            }
            { fixedDashboards.ids['tradedetails'] != 'na' && 
            <Col md="4">
            <Link to={`/dashboard/${fixedDashboards.ids['tradedetails']}`}>
                <Card>
                <TpIcapCardHeader>
                    <h3 className="mt-0">Trade Details</h3>
                </TpIcapCardHeader>
                <TpIcapCardBody>
                    <div className="text-center mb-4">
                    <img src={details_thumbnail} alt="" />
                    </div>
                    <p>
                    A Detailed view into the data presented in table format.
                    Here, each trade is displayed per row with all the trade
                    information supplied in your files enriched with market
                    and reference data along with performance measurements,
                    statistics and other analytics associated with that trade
                    or that individual security.
                    </p>
                </TpIcapCardBody>
                </Card>
            </Link>
            </Col>
            }
            { fixedDashboards.ids['outliers'] != 'na' && 
            <Col md="4">
            <Link to={`/dashboard/${fixedDashboards.ids['outliers']}`}>
                <Card>
                <TpIcapCardHeader>
                    <h3 className="mt-0">Outliers</h3>
                </TpIcapCardHeader>
                <TpIcapCardBody>
                    <div className="text-center mb-4">
                    <img src={outliers_thumbnail} alt="" />
                    </div>
                    <p>
                    A Detailed view into the best and worst performing trades
                    versus a selected benchmark (or benchprice). Here we show
                    the top and bottom ten trades in a table and chart format.
                    </p>
                </TpIcapCardBody>
                </Card>
            </Link>
            </Col>
            }
        </Row>
    );
}


export default (props: FixedDashboardProps) => {
    const { assetClass } = props;    
    return (
        <Container>
        <h2 className="mb-2">{`${assetClass?.name ?? ""} Dashboards`}</h2>          
        <p className="mb-4"></p>        
        {renderFixedDashboards(assetClass)}
        </Container>
    );
};